import { useEffect, useState } from "react";
import "./CookieBanner.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted =
      localStorage.getItem("cookies-accepted");

    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(
      "cookies-accepted",
      "true"
    );

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Este sitio utiliza únicamente
        cookies técnicas necesarias para
        su funcionamiento.{" "}

        <a href="/privacidad">
          Más información
        </a>
      </p>

      <button
        type="button"
        onClick={acceptCookies}
      >
        Aceptar
      </button>
    </div>
  );
}